import { Badge, Text } from '@change/ds-core-ui';

import { useAdvocacySupport } from './hooks/useAdvocacySupport';

export const AdvocacySupport: React.FC = () => {
	const {
		data: { totalEndorsers, categories, ariaLabelText },
	} = useAdvocacySupport();

	const gridConfig = categories.map((x) => `${x.count}fr`).join(' ');

	if (totalEndorsers === 0) return null;

	return (
		<div className="my-6 md:my-8">
			<div className="mb-4 flex justify-between" data-testid="recommender-count-wrapper">
				<Text as="h3" className="text-sm font-bold md:text-base">
					Strong community backing
				</Text>
				<div className="flex items-center gap-1">
					<Badge className="px-2" variant="neutral" label={totalEndorsers} />
					<Text as="span" className="text-sm md:text-base">
						Recommenders
					</Text>
				</div>
			</div>

			<div
				className="grid overflow-hidden rounded-full"
				style={{ gridTemplateColumns: gridConfig }}
				data-testid="composition-bar"
				// oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- not fixed to avoid regression risk from an automated markup rewrite; needs manual accessibility review
				role="img"
				aria-label={ariaLabelText}
			>
				{categories.map((item) => (
					<div key={`bar-${item.category}`} className="h-2.5" style={{ background: item.color }} role="presentation" />
				))}
			</div>

			<ul className="mt-2.5 flex flex-wrap gap-2.5 gap-y-1 md:flex-row" data-testid="legend" aria-hidden="true">
				{categories.map((item) => (
					<li key={`list-${item.category}`} className="flex items-center gap-1">
						<div className="h-2.5 w-2.5 rounded-full" style={{ background: item.color }} aria-hidden="true" />
						<p className="text-typography-weak text-xs">{item.category}</p>
					</li>
				))}
			</ul>
		</div>
	);
};
